module.exports = __webpack_public_path__ + "static/media/Header.cd276fa6.jpg";